import React, { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { loadAllContent } from "../utils/contentService";

const ContentContext = createContext();

export function ContentProvider({ children }) {
  const { i18n } = useTranslation();
  const [isReady, setIsReady] = useState(false);

  // Load content when the app mounts or language changes
  useEffect(() => {
    const loadContent = async () => {
      const language = i18n.language || "en";
      await loadAllContent(language);
      setIsReady(true);
    };

    loadContent();
  }, [i18n.language]);

  // Brief loading state only on very first render
  if (!isReady) {
    return (
      <div className="min-h-screen bg-test flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-gray-900 mx-auto mb-4"></div>
        </div>
      </div>
    );
  }

  return (
    <ContentContext.Provider value={{ isReady }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error("useContent must be used within ContentProvider");
  }
  return context;
}
